import { render, staticRenderFns } from "./campaings.vue?vue&type=template&id=1606da22&scoped=true"
import script from "./campaings.vue?vue&type=script&lang=js"
export * from "./campaings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606da22",
  null
  
)

export default component.exports